import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';

import ErrorModalContainer from '../../containers/ErrorModalContainer';
import LoadingModalContainer from '../../containers/LoadingModalContainer';
import DaySelectorContainer from '../../containers/DaySelectorContainer';
import CreateBookingTimeSelectorContainer from '../../containers/CreateBookingTimeSelectorContainer';
import PickupLocationSelectorContainer from '../../containers/PickupLocationSelectorContainer';
import PlantTypeSelectorContainer from '../../containers/PlantTypeSelectorContainer';
import PlantSelectorContainer from '../../containers/PlantSelectorContainer';
import CostCentreSelectorContainer from '../../containers/CostCentreSelectorContainer';
import TravelReasonSelectorContainer from '../../containers/TravelReasonSelectorContainer';
import JourneyToLocationSelectorContainer from '../../containers/JourneyToLocationSelectorContainer';
import AdditionalOptionsContainer from '../../containers/AdditionalOptionsContainer';
import ConfirmBookingContainer from '../../containers/ConfirmBookingContainer';
import MoreMenu from '../Common/MoreMenu';

import '../../main.css';
import './CreateStepper.css';
import '../../fixed-header-view.css';

const CREATE_BOOKING_DATE = 1;
const CREATE_BOOKING_TIME = 2;
const CREATE_BOOKING_PICKUP_FROM_LOCATION = 3;
const CREATE_BOOKING_JOURNEY_TO_LOCATION = 4;
const CREATE_BOOKING_PLANT_TYPE = 5;
const CREATE_BOOKING_PLANT = 6;
const CREATE_BOOKING_COST_CENTRE = 7;
const CREATE_BOOKING_TRAVEL_REASON = 8;
const CREATE_BOOKING_ADDITIONAL_OPTIONS = 9;
const CREATE_BOOKING_CONFIRM = 10;

export default class CreateStepper extends Component {
    static propTypes = {
        setAvailablePlant: PropTypes.func.isRequired,
        setNewBookingPlant: PropTypes.func.isRequired,
        trackCreateBookingCancel: PropTypes.func.isRequired,
        createBooking: PropTypes.func.isRequired,
        newBooking: PropTypes.object.isRequired,
        trackCreateBookingStepChange: PropTypes.func.isRequired,
        person: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
        };

        this.buildSteps();

        // capture the initiate step that is loaded
        this.props.trackCreateBookingStepChange(this.steps[this.state.step].name);

        this.handlePreviousClicked = this.handlePreviousClicked.bind(this);
        this.handleNextClicked = this.handleNextClicked.bind(this);
        this.handleCancelClicked = this.handleCancelClicked.bind(this);
        this.handleConfirmClicked = this.handleConfirmClicked.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.step !== nextState.step) {
            this.props.trackCreateBookingStepChange(this.steps[nextState.step].name);
        }
    }

    buildSteps() {
        const { person } = this.props;
        this.steps = [];

        this.steps.push({
            id: CREATE_BOOKING_DATE,
            name: `DaySelector`,
            jsx: <DaySelectorContainer />,
        });

        this.steps.push({
            id: CREATE_BOOKING_TIME,
            name: `CreateBookingTimeSelector`,
            jsx: <CreateBookingTimeSelectorContainer />,
        });

        this.steps.push({
            id: CREATE_BOOKING_PICKUP_FROM_LOCATION,
            name: `PickupLocationSelector`,
            jsx: <PickupLocationSelectorContainer />,
        });

        if (person.requirements && person.requirements.journeyToLocation) {
            this.steps.push({
                id: CREATE_BOOKING_JOURNEY_TO_LOCATION,
                name: `JourneyToLocationSelector`,
                jsx: <JourneyToLocationSelectorContainer />,
            });
        }

        this.steps.push({
            id: CREATE_BOOKING_PLANT_TYPE,
            name: `PlantTypeSelector`,
            jsx: <PlantTypeSelectorContainer />,
        });

        this.steps.push({
            id: CREATE_BOOKING_PLANT,
            name: `PlantSelector`,
            jsx: <PlantSelectorContainer />,
        });

        if (person.requirements && person.requirements.costCentre) {
            this.steps.push({
                id: CREATE_BOOKING_COST_CENTRE,
                name: `CostCentreSelector`,
                jsx: <CostCentreSelectorContainer />,
            });
        }

        this.steps.push({
            id: CREATE_BOOKING_TRAVEL_REASON,
            name: `TravelReasonSelector`,
            jsx: <TravelReasonSelectorContainer />,
        });

        if (person.requirements && person.requirements.privateUse) {
            this.steps.push({
                id: CREATE_BOOKING_ADDITIONAL_OPTIONS,
                name: `AdditionalOptions`,
                jsx: <AdditionalOptionsContainer />,
            });
        }

        this.steps.push({
            id: CREATE_BOOKING_CONFIRM,
            name: `ConfirmBooking`,
            jsx: <ConfirmBookingContainer />,
        });
    }

    handlePreviousClicked() {
        const { step } = this.state;
        if (step > 0) {
            // If we are on the vehicle select screen, and navigate backwards
            if (this.steps[step].id === CREATE_BOOKING_PLANT) {
                // Unset the selected plant and available plant list
                this.props.setAvailablePlant(null);
                this.props.setNewBookingPlant(null);
            }

            this.setState({
                step: step - 1,
            });
        }
    }

    handleNextClicked() {
        const { step } = this.state;
        const totalNumberOfSteps = this.steps.length;
        if (step + 1 < totalNumberOfSteps && this.canProgress(step)) {
            this.setState({
                step: step + 1,
            });
        }
    }

    handleCancelClicked() {
        browserHistory.push(`/bookings`);
        this.props.trackCreateBookingCancel(this.steps[this.state.step].name);
    }

    canProgress(activeStep) {
        switch (this.steps[activeStep].id) {
            case CREATE_BOOKING_DATE:
                return this.props.newBooking.startTime !== null;
            case CREATE_BOOKING_TIME:
                return this.props.newBooking.startTime !== null && this.props.newBooking.endTime !== null;
            case CREATE_BOOKING_PICKUP_FROM_LOCATION:
                return this.props.newBooking.pickupLocationId !== null;
            case CREATE_BOOKING_JOURNEY_TO_LOCATION:
                return this.props.newBooking.journeyToLocationId !== null || this.props.newBooking.otherJourneyToLocation !== null;
            case CREATE_BOOKING_PLANT_TYPE:
                return this.props.newBooking.plantType !== null; // can't use plantTypeId because this is set to null when "Any" is selected
            case CREATE_BOOKING_PLANT:
                return this.props.newBooking.plantId !== null;
            case CREATE_BOOKING_COST_CENTRE:
                return this.props.newBooking.costCentreId !== null;
            case CREATE_BOOKING_TRAVEL_REASON:
                return this.props.newBooking.travelReasonId !== null || this.props.newBooking.otherTravelReason !== null;
            case CREATE_BOOKING_ADDITIONAL_OPTIONS:
                return this.props.newBooking.privateUse !== null;
            default:
                return false;
        }
    }

    handleConfirmClicked() {
        this.props.createBooking();
    }

    render() {
        const { step } = this.state;
        const prevStepInteractionClass = step === 0 ? `disabled` : ``;
        const canProgressCssClass = this.canProgress(step) ? null : `disabled`;
        const totalNumberOfSteps = this.steps.length;
        const proceedStepJsx = step + 1 === totalNumberOfSteps
            ? <div className="done-step step-action" onClick={this.handleConfirmClicked}>Done</div>
            : <div className={`next-step step-action ${canProgressCssClass}`} onClick={this.handleNextClicked}>Next</div>;

        return (
            <div>
                <div className="stepper-wrapper">
                    <div className="floating-more-menu">
                        <MoreMenu>
                            <li onClick={this.handleCancelClicked}>Cancel</li>
                        </MoreMenu>
                    </div>
                    <div className="stepper-child-container">
                        {this.steps[step].jsx}
                    </div>
                    <div className="stepper">
                        <div className={`prev-step step-action ${prevStepInteractionClass}`} onClick={this.handlePreviousClicked}>
                            Prev
                        </div>
                        <div className="steps">
                            {step + 1}/{totalNumberOfSteps}
                        </div>
                        { proceedStepJsx }
                    </div>
                </div>
                <LoadingModalContainer />
                <ErrorModalContainer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/create/CreateStepper.jsx